<ng-template wmTemplate>
  <ng-container actions>
    @if (!loading) {
      <fa-icon class="action" [icon]="faSyncAlt" (click)="reload()"></fa-icon>
    }
    @if (loading) {
      <fa-icon class="action" [icon]="faSyncAlt" animation="spin" (click)="reload()"></fa-icon>
    }
  </ng-container>
</ng-template>

<div class="expeditions">
  @for (expedition of expeditions; track expedition) {
    <div class="expedition" [class.disabled]="locked" (click)="makeActive(expedition)" >
      <wm-browsersession [browsersession]="expedition"></wm-browsersession>
    </div>
  }
</div>
